module.exports = __webpack_public_path__ + "img/one.e0006a1c.png";